<template>
  <g>
    <path
      d="M16.257 20.2655C12.3664 20.2655 9.19922 17.0984 9.19922 13.2078V6.88222C9.19922 6.397 9.59622 6 10.0814 6H22.4326C22.9178 6 23.3148 6.397 23.3148 6.88222V13.2078C23.3148 17.0984 20.1476 20.2655 16.257 20.2655ZM10.9637 7.76445V13.2078C10.9637 16.1279 13.3368 18.5011 16.257 18.5011C19.1772 18.5011 21.5503 16.1279 21.5503 13.2078V7.76445H10.9637Z"
      :fill="iconColor"
    />
    <path
      d="M9.70225 13.7371C7.10851 13.7371 5 11.6286 5 9.03485V6.88222C5 6.397 5.397 6 5.88222 6H10.1434C10.6286 6 11.0256 6.397 11.0256 6.88222C11.0256 7.36745 10.6286 7.76445 10.1434 7.76445H6.76445V9.03485C6.76445 10.6581 8.07896 11.9727 9.70225 11.9727C10.1875 11.9727 10.5845 12.3697 10.5845 12.8549C10.5845 13.3401 10.1875 13.7371 9.70225 13.7371Z"
      :fill="iconColor"
    />
    <path
      d="M22.8028 13.7371C22.3176 13.7371 21.9206 13.3401 21.9206 12.8549C21.9206 12.3697 22.3176 11.9727 22.8028 11.9727C24.4261 11.9727 25.7406 10.6493 25.7406 9.03485V7.76445H22.3617C21.8765 7.76445 21.4795 7.36745 21.4795 6.88222C21.4795 6.397 21.8765 6 22.3617 6H26.6229C27.1081 6 27.5051 6.397 27.5051 6.88222V9.03485C27.5051 11.6286 25.3966 13.7371 22.8028 13.7371Z"
      :fill="iconColor"
    />
    <path
      d="M16.1435 23.4945C15.6582 23.4945 15.2612 23.0975 15.2612 22.6123V19.6745C15.2612 19.1892 15.6582 18.7922 16.1435 18.7922C16.6287 18.7922 17.0257 19.1892 17.0257 19.6745V22.6123C17.0257 23.1063 16.6287 23.4945 16.1435 23.4945Z"
      :fill="iconColor"
    />
    <path
      d="M23.0485 26.0006H9.22402C8.7388 26.0006 8.3418 25.6036 8.3418 25.1184C8.3418 24.6331 8.7388 24.2361 9.22402 24.2361H23.0485C23.5337 24.2361 23.9307 24.6331 23.9307 25.1184C23.9307 25.6036 23.5337 26.0006 23.0485 26.0006Z"
      :fill="iconColor"
    />
    <path
      d="M18.8587 23.7134H13.4154C12.9302 23.7134 12.5332 23.3164 12.5332 22.8311C12.5332 22.3459 12.9302 21.9489 13.4154 21.9489H18.8587C19.344 21.9489 19.741 22.3459 19.741 22.8311C19.741 23.3252 19.344 23.7134 18.8587 23.7134Z"
      :fill="iconColor"
    />
  </g>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    iconColor: { type: String, default: "#ee1c25" }
  }
})
export default class IconRanking extends Vue {
  iconColor!: string;
}
</script>
